/* Button Up Boutique — Theme JS */

// Header scroll shadow
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
}

// Mobile nav
const menuToggle = document.querySelector('.menu-toggle');
const mobileNav = document.querySelector('.mobile-nav');
const mobileNavClose = document.querySelector('.mobile-nav__close');
const mobileNavOverlay = document.querySelector('.mobile-nav__overlay');

if (menuToggle && mobileNav) {
  const openMobileNav = () => mobileNav.classList.add('open');
  const closeMobileNav = () => mobileNav.classList.remove('open');
  menuToggle.addEventListener('click', openMobileNav);
  mobileNavClose?.addEventListener('click', closeMobileNav);
  mobileNavOverlay?.addEventListener('click', closeMobileNav);
}

// Hero carousel
class HeroCarousel {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('.hero-carousel__track');
    this.slides = el.querySelectorAll('.hero-slide');
    this.dots = el.querySelectorAll('.carousel-dot');
    this.current = 0;
    this.total = this.slides.length;
    this.interval = null;

    el.querySelector('.carousel-btn--prev')?.addEventListener('click', () => this.prev());
    el.querySelector('.carousel-btn--next')?.addEventListener('click', () => this.next());
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));

    if (this.total > 1) this.startAuto();

    // Touch support
    let startX = 0;
    this.track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    this.track.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) diff > 0 ? this.next() : this.prev();
    }, { passive: true });
  }

  goTo(index) {
    this.current = (index + this.total) % this.total;
    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.dots.forEach((d, i) => d.classList.toggle('active', i === this.current));
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }

  startAuto() {
    this.interval = setInterval(() => this.next(), 5000);
    this.el.addEventListener('mouseenter', () => clearInterval(this.interval));
    this.el.addEventListener('mouseleave', () => { this.interval = setInterval(() => this.next(), 5000); });
  }
}

document.querySelectorAll('.hero-carousel').forEach(el => new HeroCarousel(el));

// Cart drawer
const cartDrawer = document.querySelector('.cart-drawer');
const cartOverlay = document.querySelector('.cart-drawer-overlay');

const openCart = () => {
  cartDrawer?.classList.add('open');
  cartOverlay?.classList.add('open');
  document.body.style.overflow = 'hidden';
};
const closeCart = () => {
  cartDrawer?.classList.remove('open');
  cartOverlay?.classList.remove('open');
  document.body.style.overflow = '';
};

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-open-cart]')) openCart();
  if (e.target.closest('[data-close-cart]')) closeCart();
});
cartOverlay?.addEventListener('click', closeCart);

// Cart drawer — qty change and remove
document.addEventListener('click', async (e) => {
  const qtyBtn = e.target.closest('.cart-qty-btn');
  const removeBtn = e.target.closest('[data-remove]');

  if (qtyBtn) {
    const line = parseInt(qtyBtn.dataset.line);
    const change = parseInt(qtyBtn.dataset.change);
    const valEl = qtyBtn.closest('.cart-line-item__qty').querySelector('.cart-qty-val');
    const current = parseInt(valEl.textContent) || 1;
    const next = Math.max(0, current + change);
    await updateCartLine(line, next);
  }

  if (removeBtn) {
    const line = parseInt(removeBtn.dataset.line);
    await updateCartLine(line, 0);
  }
});

async function updateCartLine(line, quantity) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    if (res.ok) await renderCartDrawer();
  } catch(_) {}
}

function escHtml(str) {
  return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

async function renderCartDrawer() {
  console.log('[Cart] renderCartDrawer() start');
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    console.log('[Cart] /cart.js — item_count:', cart.item_count, '| total_price:', cart.total_price);

    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    const body = document.getElementById('cart-drawer-items');
    const subtotalEl = document.getElementById('cart-drawer-subtotal');
    console.log('[Cart] #cart-drawer-items found:', !!body);
    if (!body) { console.warn('[Cart] #cart-drawer-items not in DOM'); return; }

    if (cart.item_count === 0) {
      body.innerHTML = `<div class="cart-drawer__empty"><p>Your bag is empty.</p><a href="/collections/all" class="btn btn--outline" style="margin-top:1.5rem;">Continue Shopping</a></div>`;
    } else {
      body.innerHTML = cart.items.map((item, i) => {
        const line = i + 1;
        const price = (item.final_line_price / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
        const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="cart-line-item__variant">${escHtml(item.variant_title)}</p>` : '';
        return `<div class="cart-line-item" data-line="${line}">
          <a href="${item.url}" class="cart-line-item__img-wrap">
            <img class="cart-line-item__img" src="${item.image}" alt="${escHtml(item.title)}" width="80" loading="lazy">
          </a>
          <div class="cart-line-item__details">
            <a href="${item.url}" class="cart-line-item__title">${escHtml(item.product_title)}</a>
            ${variantHtml}
            <div class="cart-line-item__meta">
              <div class="cart-line-item__qty">
                <button type="button" class="cart-qty-btn" data-line="${line}" data-change="-1" aria-label="Decrease quantity">−</button>
                <span class="cart-qty-val">${item.quantity}</span>
                <button type="button" class="cart-qty-btn" data-line="${line}" data-change="1" aria-label="Increase quantity">+</button>
              </div>
              <button type="button" class="cart-line-item__remove" data-line="${line}" data-remove aria-label="Remove ${escHtml(item.product_title)}">Remove</button>
            </div>
          </div>
          <p class="cart-line-item__price">${price}</p>
        </div>`;
      }).join('');
    }

    if (subtotalEl) {
      subtotalEl.textContent = (cart.total_price / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
    }
    console.log('[Cart] renderCartDrawer() done');
  } catch(err) {
    console.error('[Cart] renderCartDrawer() error:', err);
  }
}

// Add to cart (basic fetch)
document.addEventListener('submit', async (e) => {
  if (!e.target.matches('[data-cart-form]')) return;
  e.preventDefault();
  const form = e.target;
  const btn = form.querySelector('[data-atc]');
  const original = btn.textContent;
  btn.textContent = 'Adding…';
  btn.disabled = true;
  console.log('[Cart] ATC submit — POSTing to /cart/add.js');

  try {
    const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    console.log('[Cart] /cart/add.js status:', res.status, '| ok:', res.ok);
    if (res.ok) {
      btn.textContent = 'Added!';
      await renderCartDrawer();
      openCart();
    }
  } catch(err) { btn.textContent = 'Error'; console.error('[Cart] ATC error:', err); }
  finally { setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1800); }
});

async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  } catch(_) {}
}

// Product gallery thumbnails
document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const main = thumb.closest('.product-gallery').querySelector('.product-gallery__main img');
    if (main) {
      const src = thumb.querySelector('img').src.replace(/width=\d+/, 'width=1000');
      main.style.opacity = '0';
      const newImg = new Image();
      newImg.onload = () => { main.src = src; main.srcset = ''; main.style.opacity = '1'; };
      newImg.src = src;
    }
    thumb.closest('.product-gallery__thumbs').querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Product accordion
document.querySelectorAll('.accordion-trigger').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const body = trigger.nextElementSibling;
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', !expanded);
    body.classList.toggle('open', !expanded);
  });
});

// Size/variant selectors
document.querySelectorAll('.size-btn, .swatch-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    btn.closest('.size-group, .swatch-group').querySelectorAll('.size-btn, .swatch-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const variantId = btn.dataset.variantId;
    if (variantId) {
      const input = document.querySelector('[name="id"]');
      if (input) input.value = variantId;
    }
  });
});

// Quantity stepper
document.querySelectorAll('.qty-stepper').forEach(stepper => {
  stepper.querySelectorAll('button').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = stepper.querySelector('input');
      const val = parseInt(input.value) || 1;
      input.value = btn.dataset.dir === 'up' ? val + 1 : Math.max(1, val - 1);
    });
  });
});

// Init cart count on load
refreshCart();
